import React from 'react';
import PropTypes from 'prop-types';
import browser from 'jquery.browser';

import { objHasProp } from 'newJs/utils';
import externalHandlers from 'containers/Attachments/handlers/external';

const escKeyHandler = (callBack) => (evt) => {
    if (typeof callBack !== 'function') {
        return;
    }
    if (evt.keyCode !== 27) {
        return;
    }
    callBack();
};

const ParamsContext = React.createContext();

class ParamsProvider extends React.PureComponent {
    constructor(props) {
        super(props);
        const { apiHost, currentFolder, MAPI, msgUID } = props.value;
        this.state = {
            ...this.props.value,
            browser,
            escKeyHandler,
            handleClick: externalHandlers({ apiHost, currentFolder, MAPI, msgUID }),
            isApiEnabled: apiName => {
                // return false;
                // if (apiName === 'foto') {
                //     return false;
                // }
                return objHasProp(apiName, apiHost);
            }
        };
    }
    render() {
        return (
            <ParamsContext.Provider value={this.state}>
                {this.props.children}
            </ParamsContext.Provider>
        );
    }
}

ParamsProvider.propTypes = {
    children: PropTypes.node.isRequired,
    value: PropTypes.object,
};

export const useAttachsParams = () => {
    const context = React.useContext(ParamsContext);

    if (context === undefined) {
        throw new Error('useAttachsParams must be used within AttachsParamsProvider');
    }

    return context;
};

export const AttachsParamsContext = ParamsContext;
export default ParamsProvider;